import typography from '../theme/typography';

const styleOverrides = {
  root: {
    '& > tr': {
      '&:hover': {
        backgroundColor: 'initial',
      },
    },
    '& th': {
      fontWeight: typography.fontWeightRegular,
      verticalAlign: 'bottom',
    },
  },
};

export default styleOverrides;
